module.exports = __webpack_public_path__ + "static/img/06.cfe43968.png";